// Story 8.14 (FR85 remainder) — informational review-flag copy.
// One sentence, invented at the 2026-09-21 checkpoint (D3/D9). Screens 19 and 21
// do not draw this note; placement is beside the two numeric values. Never
// blocking, never pass/fail. Forbidden tokens: blocked, hold, failed, retry,
// Director, pass, fail, required.

import type { CalibrationReviewStatus } from "@/hooks/queries/calibration-status-types";

export const OUTSIDE_LEGACY_RANGE: CalibrationReviewStatus = "outside_legacy_range";

export const CALIBRATION_REVIEW_FLAG_COPY =
  "One or more of these measures sits outside the historical ±0.9 range. Live scoring is not affected.";

export function CalibrationReviewNote({
  status,
}: {
  status?: CalibrationReviewStatus | null;
}) {
  if (status !== OUTSIDE_LEGACY_RANGE) return null;
  return (
    <p className="text-sm text-[color:var(--text-tertiary)]">{CALIBRATION_REVIEW_FLAG_COPY}</p>
  );
}
